export default __webpack_public_path__ + "d35b3e29b86d7129831f18acf746b4dc.svg";